import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_78: FaireProductEntity = {
  token: "starter_collection_78",
  type: "product",
  name: "Mini Alive Olive Oil",
  brandName: "Brightland",
  imageUrl:
    '"https://cdn.faire.com/fastly/2462e92c8a104e47578610d7426e899ac95d0578bb0818af8d11d82b8d309c9b.png?bg-color=FFFFFF&dpr=2&fit=crop&format=jpg&height=720&precrop=611',
  priceDollars: 15,
  msrpDollars: 30,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
